import React from 'react';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import { ReminderIcon } from 'components/icons';
import { t } from '@lingui/macro';
import { ReminderModal } from './ReminderModal';
import { useDisclosure } from '@cardboard-ui/react';

interface ReminderOptionProps {
  nodeId: string;
}

export const ReminderOption = ({ nodeId }: ReminderOptionProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <OptionsMenuItem icon={<ReminderIcon />} onClick={onOpen}>
        {t`Send a reminder`}
      </OptionsMenuItem>
      <ReminderModal isOpen={isOpen} onClose={onClose} nodeId={nodeId} />
    </>
  );
};
